var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_206_57",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_206_57",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAABi0lEQVRYhe1X7W2DMBB9rfo/jMAGZQQ6QTMCI7BBGYFuQDegG9AN6AQlGzgTXOXqjFxzGJuQIrV9kqVArLt3H7l3uSEi7InbXb3/ZgLpHgRyAA2AAcAHAN1cCkAFIHHIVeOTbkI+KRENRJRZ70JPQX4oIiqJqOVbrbFrOyj5SxVJ4rjg3IXiYL982CUwaToA6AAcA1NfR5ZKl6gf7VuRVALbltnORZ9HRm/QGBt2BpTA9pHZ1jOdnUdGr/ECoBifnCZcQs+9knmytoRvWXRT2kYaU5H3e5eAXYKSm+8ckc5DZPonZb6zPutfwVOkwYthZ6D/AX+d+8Im0AI4XZnAJEhXCwr3wsbwZgB84SGyEUPxKjWhpIbJlcrRSC+llSxlOd0Sp7kdQcqAFovnjQnM95ZHaNaMWQm1T86XtD5lA8NK55PR6xvFEhSfZOGehPcgtfTofL1CbAy0qCUhG9XW9Va8Hwbvk269mwscV6FR20eaAwnva7p+GYD7meq98WzveHCtwv9/wz9OAMAndpmfJkJ3buQAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.efde91d70880c068dd687e7a72e10b6a.svg";
export { ForwardRef as ReactComponent };